<template>
  <v-container>
    <v-row dense>
      <v-col cols="12" xs="12" sm="12">
        <highcharts :options="chartOptions"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
/* eslint-disable no-debugger */
import { Chart } from "highcharts-vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "chartAfiliados",
  data() {
    return {
      valores: [],
      meses: [],
      totales: [],
    };
  },
  beforeMount() {
    this.graficar();
  },
  components: {
    highcharts: Chart,
  },
  props: {
    title: String,
    modo: String,
    array: Array,
  },
  watch: {
    array: function(val) {
      this.graficar();
      console.log(val);
    },
  },
  methods: {
    graficar() {
      let arr = this.array;
      let me = this;
      let mesn = "";
      // Se reinician antes de recorrer: el watch de `array` vuelve a llamar a
      // graficar() en cada refresco y sin esto los meses/totales se acumulaban,
      // duplicando las barras del gráfico.
      me.meses = [];
      me.totales = [];
      arr.forEach(function(x) {
        switch (parseInt(x._id.mes)) {
          case 1:
            mesn = "Enero";
            break;
          case 2:
            mesn = "Febrero";
            break;
          case 3:
            mesn = "Marzo";
            break;
          case 4:
            mesn = "Abril";
            break;
          case 5:
            mesn = "Mayo";
            break;
          case 6:
            mesn = "Junio";
            break;
          case 7:
            mesn = "Julio";
            break;
          case 8:
            mesn = "Agosto";
            break;
          case 9:
            mesn = "Setiembre";
            break;
          case 10:
            mesn = "Octubre";
            break;
          case 11:
            mesn = "Noviembre";
            break;
          case 12:
            mesn = "Diciembre";
            break;
          default:
            mesn = "error";
        }

        me.meses.push(mesn + " de " + x._id.year);
        // let total = new Number(x.total)
        // total = total.toPrecision(6)
        me.totales.push(x.total);
      });
    },
  },
  computed: {
    ...mapState("userNamespace", ["token"]),
    chartOptions() {
      // Highcharts renderiza con tema claro por defecto: sobre el backoffice
      // oscuro quedaba un rectángulo blanco. Todo lo de abajo lo adapta.
      const TEXT = "rgba(255,255,255,0.62)";
      const TEXT_STRONG = "rgba(255,255,255,0.94)";
      const GRID = "rgba(255,255,255,0.07)";
      // Slot 1 de la paleta categórica validada para superficie oscura.
      const SERIE = "#3987e5";

      return {
        chart: {
          type: this.modo,
          backgroundColor: "transparent",
          style: { fontFamily: "inherit" },
          spacing: [8, 8, 8, 8],
        },
        title: {
          text: this.title,
          align: "left",
          style: { color: TEXT_STRONG, fontSize: "15px", fontWeight: "650" },
        },
        credits: { enabled: false },
        // Una sola serie: el título ya la nombra, la leyenda solo agrega ruido.
        legend: { enabled: false },
        xAxis: {
          categories: this.meses,
          crosshair: { color: "rgba(255,255,255,0.06)" },
          lineColor: GRID,
          tickColor: GRID,
          labels: { style: { color: TEXT, fontSize: "11px" } },
        },
        yAxis: {
          min: 0,
          title: { text: null },
          gridLineColor: GRID,
          labels: { style: { color: TEXT, fontSize: "11px" } },
        },
        tooltip: {
          backgroundColor: "rgba(20,17,28,0.96)",
          borderColor: "rgba(255,255,255,0.14)",
          borderRadius: 6,
          style: { color: TEXT_STRONG, fontSize: "12px" },
          headerFormat: '<span style="font-size:11px;opacity:.7">{point.key}</span><br/>',
          pointFormat: "<b>{point.y:,.0f}</b> afiliaciones",
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          column: {
            pointPadding: 0.12,
            groupPadding: 0.12,
            borderWidth: 0,
            borderRadius: 3,
            color: SERIE,
            states: { hover: { brightness: 0.16 } },
          },
        },
        series: [
          {
            name: "Afiliaciones",
            data: this.totales,
          },
        ],
      };
    },
  },
};
/* eslint-disable no-debugger */
</script>
